import { Pipe, PipeTransform } from '@angular/core';

import { Utils } from 'app/utils/utils';

@Pipe({
  name: 'truncateEnd',
  standalone: false,
})
export class TruncateEndPipe implements PipeTransform {
  transform(value: string, limit = 20, separator = '…'): string {
    return Utils.truncateEnd(value, limit, separator);
  }
}
